import { Modal, Checkbox, Button, LoadingOverlay } from '@mantine/core';
import ModalComponent from '../../../components/modal';
import { Language } from '../../../languages/languageHandler';
import { useEffect, useRef, useState } from 'react';
import { IntializationHelpdeskEquipment } from '../../../../libraries/helpdesk/equipments';
import { useStatusOperDialog } from '../../../context/status-oper-dialog';
import { StatusType } from '../../../../libraries/zps';
import './styles.scss';

interface ModalProps {
  isOpen: boolean;
  hideBtn: () => void;
  lang: Language;
  eid: number;
  isInitAccepted: boolean;
  autorizeInitialization: () => void;
}

const AutorizeInitializationModal = ({
  isOpen,
  hideBtn,
  lang,
  eid,
  isInitAccepted,
  autorizeInitialization
}: ModalProps) => {
  const controller = useRef(new AbortController()).current;

  const [initAccepted, setInitAccepted] = useState(isInitAccepted);
  const [loading, setLoading] = useState(false);

  const { showStatusOperDialog, handleApiError } = useStatusOperDialog();

  useEffect(() => {
    setInitAccepted(isInitAccepted);
  }, [isInitAccepted]);

  const handleSave = async () => {
    setLoading(true);

    try {
      const response = await IntializationHelpdeskEquipment({ eid, initAccepted }, controller);

      const statusOper = response?.data.statusOper;

      if (!statusOper || statusOper.code !== 0) {
        handleApiError(response, lang.EQUIPMENT_AUTHORIZE_INITIALIZATION_ERROR || 'Operation failed');
        return;
      }

      showStatusOperDialog({
        type: StatusType.INFO,
        message: lang.EQUIPMENT_AUTHORIZE_INITIALIZATION_SUCCESS || 'Operation completed',
        statusOper
      });

      autorizeInitialization();
      hideBtn();
    } catch (error) {
      handleApiError(error, lang.EQUIPMENT_AUTHORIZE_INITIALIZATION_ERROR || 'Operation failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalComponent
      show={isOpen}
      handleClick={hideBtn}
      title={`${lang.EQUIPMENT_AUTHORIZE_INITIATION} - ${eid}`}
      classname="autorize-initialization"
      content={
        <Modal.Body style={{ margin: 0, padding: 0 }}>
          <LoadingOverlay visible={loading} />

          <Checkbox
            label={lang.EQUIPMENT_AUTHORIZE_INITIATION || 'Initialization Accepted'}
            checked={initAccepted}
            onChange={event => setInitAccepted(event.currentTarget.checked)}
          />

          <Button radius="md" onClick={handleSave} disabled={loading}>
            {lang.GLOBAL_SAVE_BUTTON || 'Save'}
          </Button>
        </Modal.Body>
      }
    />
  );
};

export default AutorizeInitializationModal;
